import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(private keycloak: KeycloakService) {}

  getHaendlerId(): number {
    const token = this.keycloak.getKeycloakInstance().tokenParsed as any;
    return token?.profile?.haendlerId ?? token?.haendlerId;
  }

  getHaendlerBezeichnung(): string {
    const token = this.keycloak.getKeycloakInstance().tokenParsed as any;
    return token?.profile?.haendlerBezeichnung ?? token?.haendlerBezeichnung ?? '';
  }

  getUserId(): string {
    const token = this.keycloak.getKeycloakInstance().tokenParsed as any;
    return token?.sub ?? '';
  }

  getToken(): string {
    return this.keycloak.getKeycloakInstance().token ?? '';
  }

  getUserName(): string {
    const token = this.keycloak.getKeycloakInstance().tokenParsed as any;
    return token?.name ?? token?.preferred_username ?? '';
  }

  logout(): void {
    this.keycloak.logout();
  }

  isLoggedIn(): boolean {
    return this.keycloak.getKeycloakInstance().authenticated ?? false;
  }

  isImpersonated(): boolean {
    const token = this.keycloak.getKeycloakInstance().tokenParsed as any;
    return !!token?.impersonator?.id;
  }

  hasRole(role: string): boolean {
    return this.keycloak.isUserInRole(role);
  }
}
